// extracted by mini-css-extract-plugin
module.exports = {"confettiWrap":"k2qA6O"};